module.exports = __webpack_public_path__ + "static/media/FPI-and-me-fr-program.07594105.png";